import React from 'react';

export interface SnapshotProps {
    url: string;
    title: string;
}

function Snapshot({ url, title }: SnapshotProps): React.JSX.Element {
    return (
        <div className="flex flex-col gap-2">
            <h5 className="text-lg font-semibold">{title}</h5>
            <img src={url} alt="" className="h-auto w-full" />
        </div>
    );
}

export default Snapshot;
